// extracted by mini-css-extract-plugin
export var container = "MeetUsBlock-module--container--V6fvV";
export var subContainer = "MeetUsBlock-module--subContainer--+t9lF";
export var meetUsSingleBlockContainer = "MeetUsBlock-module--meetUsSingleBlockContainer--7E1K5";
export var leftElement = "MeetUsBlock-module--leftElement--rtW3F";
export var rightElement = "MeetUsBlock-module--rightElement--9jGCw";
export var icon = "MeetUsBlock-module--icon--i3jwF";